const initialValues = (
  user,
  user_address,
  seller
) => ({
  name                   : user?.name || '',
  email                  : user?.email || '',
  mobile                 : user?.mobile || '',
  birthday               : user?.birthday || '',
  gender                 : user?.gender || '',
  customer_type          : user?.gender || '',
  sign_up_affiliate_name : user?.sign_up_affiliate_name ?? '',
  verification_method    : '',
  is_verified            : false,

  user_address: {
    street_address      : user_address?.street_address ?? '',
    tl_province_id      : user_address?.tl_province?.id ?? '',
    tl_city_id          : user_address?.tl_city?.id ?? '',
    tl_district_id      : user_address?.tl_district?.id ?? '',
    tl_sub_district_id  : user_address?.tl_sub_district?.id ?? '',
    recipient_name      : user_address?.recipient_name ?? '',
    telephone           : user_address?.telephone ?? '',
    alias               : user_address?.alias ?? '',
    postal_code         : user_address?.postal_code ?? '',
    is_customer_default : user_address?.is_customer_default ?? true
  },

  seller: {
    name        : seller?.name ?? '',
    username    : seller?.username ?? '',
    email       : seller?.email ?? '',
    mobile      : seller?.mobile ?? '',
    birthday    : seller?.birthday ?? '',
    gender      : seller?.gender ?? '',
    referrer    : seller?.referrer ?? '',
    seller_type : seller?.seller_type ?? '',
    contract_id : seller?.contract?.id ?? '',

    street_address : seller?.street_address ?? '',
    kecamatan      : seller?.kecamatan ?? '',
    kelurahan      : seller?.kelurahan ?? '',
    kota           : seller?.kelurahan ?? '',
    kode_pos       : seller?.kode_pos ?? '',
    provinsi       : seller?.provinsi ?? '',

    bank           : seller?.bank ?? '',
    bank_branch    : seller?.bank_branch ?? '',
    account_number : seller?.account_number ?? '',
    account_name   : seller?.account_name ?? ''
  }
})
export default initialValues
